import { observer } from "mobx-react-lite";

import { SymbolNode } from "@/components/expression/SymbolNode";
import { UnitNode } from "@/components/expression/UnitNode";
import * as Node from "@/components/expression/utils/layout";
import { EditNodeInput } from "@/components/input/EditNodeInput";
import { useTooltip } from "@/components/tooltip/Tooltip";
import { twMerge } from "@/utils/twMerge";

import type { ExpressionComponent } from "./types";

export const ConstantNode: ExpressionComponent<"constant"> = observer(function ConstantNode({
  node,
  className,
}) {
  const { handlerProps, tooltip } = useTooltip({
    title: node.name,
    focusProps: {
      enabled: false,
    },
    hoverProps: {
      delay: {
        open: 1500,
      },
    },
  });

  return (
    <>
      <div className={twMerge("flex items-baseline", className)}>
        {node.unitNode?.placement === "prefix" && <UnitNode node={node.unitNode} />}
        <EditNodeInput node={node} inputClassName="rounded-full">
          <Node.Container node={node} radius="rounded" data-testid="atomic-node" {...handlerProps}>
            {node.symbolNode && <SymbolNode node={node.symbolNode} />}
          </Node.Container>
        </EditNodeInput>
        {node.unitNode?.placement === "postfix" && <UnitNode node={node.unitNode} />}
      </div>
      {tooltip}
    </>
  );
});
